<template>
  <div v-if="getRecommendLinks().length > 0" class="mt-1">
    <div v-for="(link, index) in getRecommendLinks()" :key="index" class="mt-1">
      <a :href="link.url" :target="link.target" class="button-primary button-is-small block button-icon icon-left">
        <!--
        <svg xmlns="http://www.w3.org/2000/svg" width="16.35" height="26.312" viewBox="0 0 16.35 26.312">
          <g transform="translate(-39.328 -413.288)">
            <path data-name="Icon awesome-bus" d="M15.584,4.088h-.255V2.555C15.328,1.124,12.16,0,8.175,0S1.022,1.124,1.022,2.555V4.088H.766A.766.766,0,0,0,0,4.854V7.409a.767.767,0,0,0,.766.766h.255v5.109a1.022,1.022,0,0,0,1.022,1.022v1.022A1.022,1.022,0,0,0,3.066,16.35H4.088a1.022,1.022,0,0,0,1.022-1.022V14.306h6.131v1.022a1.022,1.022,0,0,0,1.022,1.022h1.022a1.022,1.022,0,0,0,1.022-1.022V14.306h.2a.806.806,0,0,0,.818-.817V8.175h.255a.767.767,0,0,0,.766-.766V4.854A.766.766,0,0,0,15.584,4.088ZM3.577,12.773A1.022,1.022,0,1,1,4.6,11.752,1.022,1.022,0,0,1,3.577,12.773ZM4.088,9.2A1.022,1.022,0,0,1,3.066,8.175V4.088A1.022,1.022,0,0,1,4.088,3.066h8.175a1.022,1.022,0,0,1,1.022,1.022V8.175A1.022,1.022,0,0,1,12.262,9.2Zm8.686,3.577A1.022,1.022,0,1,1,13.8,11.752,1.022,1.022,0,0,1,12.773,12.773Z" transform="translate(39.328 423.25)" fill="#fff"/>
            <path data-name="Icon awesome-wifi" d="M12.7,4.708a9.3,9.3,0,0,0-12.6,0,.318.318,0,0,0-.007.46l.685.68a.325.325,0,0,0,.448.008,7.675,7.675,0,0,1,10.348,0,.325.325,0,0,0,.448-.008l.685-.68a.318.318,0,0,0-.007-.46ZM6.4,8.652a1.28,1.28,0,1,0,1.28,1.28A1.28,1.28,0,0,0,6.4,8.652Zm4.054-1.672a6.141,6.141,0,0,0-8.109,0,.316.316,0,0,0-.011.463l.689.68a.327.327,0,0,0,.441.016,4.506,4.506,0,0,1,5.871,0,.326.326,0,0,0,.441-.016l.689-.68A.316.316,0,0,0,10.456,6.979Z" transform="translate(41 411.038)" fill="#fff"/>
          </g>
        </svg>
        -->
        {{ link.label }}
      </a>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    editable: {
      type: Boolean,
      default: function () {
        return false
      }
    },
    tickets: {
      type: Array,
      default: function () {
        return []
      }
    }
  },
  methods: {
    getRecommendLinks: function () {
      var links = []
      for (let i = 0; i < this.tickets.length; i++) {
        links.push({
          label: this.tickets[i].label,
          url: this.tickets[i].url,
          target: this.tickets[i].target
        })
      }
      return links
    }
  }
}
</script>
